import React from 'react';
import ServiceDetail from '@/components/services/ServiceDetail';

export default function GarageDoorCableRepair() {
  return <ServiceDetail serviceKey="cables" />;
}